import React, { lazy, Suspense } from 'react';
import BlockContainer from './BlockContainer';

const tools = {
  FormBuilder: lazy(() => import('../FormBuilder')),
};

export default function CustomTool({
  title,
  description,
  bgColor,
  textColor,
  padding,
  tool,
  props,
}) {
  const Tool = tools[tool];

  let parsedProps = {};
  try {
    parsedProps = JSON.parse(props || '{}');
  } catch (e) {
    console.error('Error parsing props', e);
  }

  return (
    <BlockContainer
      bgColor={bgColor}
      textColor={textColor}
      padding={padding}
      title={title}
      description={description}
    >
      <Suspense fallback={<div>Loading...</div>}>
        {Tool ? <Tool {...parsedProps} /> : null}
      </Suspense>
    </BlockContainer>
  );
}
